export default __webpack_public_path__ + "static/media/logo_lg.fefdf5c4.png";